import $ from 'jquery'
import 'bootstrap-4-slider'

// Can't use data-attribute, because it won't work with Turbo
$(document).on('turbo:load', () => {
  $('input.slider').bootstrapSlider()
})
